import Home from './components/Home.vue'
import FourOhFour from './components/FourOhFour.vue'
import Profile from './components/Profile.vue'

export const routes = [
	{ path: '', component: Home, name: "Home"},
	{ path: '/profile/:leaId', component: Profile, name: 'Profile', props: true},
	{ path: '*', component: FourOhFour},
]


